import { fontWeight } from '@/theme';
import Box from '@mui/material/Box';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Stack, { StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export default function Banner({
  title,
  category,
  closed,
  src,
  onClick,
  buttonProps,
  slide,
  ...props
}: {
  category?: string;
  title?: string;
  closed?: boolean;
  src?: string | null;
  onClick?: () => void;
  buttonProps?: IconButtonProps;
  slide?: boolean | null;
} & StackProps) {
  const theme = useTheme();
  return (
    <>
      {slide ? (
        <IconButton onClick={onClick} sx={{ p: 0 }} {...buttonProps}>
          <img
            src={'https://static-hupay.s3.ap-northeast-2.amazonaws.com/shuffle/20191204_155513_fCrOqdMXS6.png'}
            alt="banner event"
            width="100%"
            height={'auto'}
          />
        </IconButton>
      ) : (
        // <img
        //   src={'https://static-hupay.s3.ap-northeast-2.amazonaws.com/shuffle/20191204_155513_fCrOqdMXS6.png'}
        //   alt="banner event"
        //   width={100}
        //   height={'auto'}
        // />
        <IconButton onClick={onClick} sx={{ p: 0 }} {...buttonProps}>
          <Stack
            bgcolor={theme.palette.primary.main}
            width="100%"
            borderRadius={2}
            direction="row"
            px={3}
            py={2.5}
            position="relative"
            overflow="hidden"
            {...props}
            // style={{
            //   backgroundImage: process.env.REACT_APP_API_URL + src,
            //   backgroundRepeat: 'no-repeat',
            //   backgroundSize: 'contain',
            // }}
          >
            <Box textAlign="left">
              <Typography
                variant="body2"
                fontWeight={fontWeight.Bold}
                sx={{
                  color: '#DCDAFF',
                }}
              >
                {category}
              </Typography>
              <Typography variant="h6" fontWeight={fontWeight.Bold} color="white">
                {title}
              </Typography>
            </Box>
            {/* <Box position="absolute" right="24px">
          {src && <img src={process.env.REACT_APP_API_URL + src} alt="banner event" />}
        </Box> */}
            {closed && (
              <Stack
                position="absolute"
                left={0}
                top={0}
                bgcolor="rgba(0,0,0,0.5)"
                width="100%"
                height="100%"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="body2" color="white" fontWeight={fontWeight.Bold}>
                  종료된 이벤트입니다.
                </Typography>
              </Stack>
            )}
          </Stack>
        </IconButton>
      )}
    </>
  );
}
